import { isDefined, initArray } from "../../shared/utils";
import fileSys from "../../fileoprators/fileSystem";
const fs = window.require("fs");
const ZenrikeCnt = 45;
class ZernikeConfig {
  constructor(zernikeSet = { order: 45 }, zernikeParams) {
    this.iconPath = fileSys.getStaticImagePath("zernikes");
    this.zernikeIcons = [];
    this.configPath = fileSys.getTopographyCfgPath("zernikeSettings.json");
    this.initZerikeIcons();
    this._enabledCnt = this._calcEnabledCnt(zernikeSet.order);
  }
  _calcEnabledCnt(order) {
    return ((order + 1) * (order + 2)) / 2;
  }
  setZernikeParamValues(values) {
    for (let i = 0; i < ZenrikeCnt; i++) {
      this.zernikeParamValues[i] = values[i];
    }
  }
  setZenikeEnableCnt(order) {
    this._enabledCnt = this._calcEnabledCnt(order);
  }
  isEnabled(index) {
    return index < this._enabledCnt;
  }
  _initDefaultZernikeParams(mode) {
    let params = [];
    for (let n = 0; n < 9; n++) {
      for (let m = 0; m < n + 1; m++) {
        let v = Object.create(null);
        v.index = (n * (n + 1)) / 2 + m;
        v.nIndex = n;
        v.mIndex = -n + m * 2;
        v.selected = this.isSelected(mode, v.index);
        v.enabled = true;
        params[(n * (n + 1)) / 2 + m] = v;
      }
    }
    return params.concat();
  }
  initZerikeIcons() {
    for (let i = 0; i < 65; i++) {
      this.zernikeIcons[i] = new Image();
      this.zernikeIcons[i].src = `file://${this.iconPath}/${i}.svg`;
    }
  }
  initZernikeParams() {
    return this._initDefaultZernikeParams();
  }
  getZerinkeParamIndex(n, m) {
    return (n * (n + 1)) / 2 + m;
  }
  getZerinkeParamNM(index) {
    const result = this.initZernikeParams.filter((item) => {
      return item.index === index;
    });

    if (isDefined(result) && result.length > 0) {
      const { nIindex, mIndex } = result[0];
      return { nIindex, mIndex };
    } else {
      return {
        nIindex: -1000,
        mIndex: -1000
      };
    }
  }
  isSelected(mode, index) {
    let value = true;
    switch (mode) {
      case "LOA":
        value = !!(index > 2 && index < 6);
        break;
      case "HOA":
        value = index > 5;
        break;
      case "ALL-ON":
        value = true;
        break;
      case "ALL-OFF":
        value = false;
        break;
      default:
        break;
    }
    return value;
  }
}
let zernikeConfig = new ZernikeConfig();
export let { zernikeIcons } = zernikeConfig;
export default ZernikeConfig;



// WEBPACK FOOTER //
// ./src/topography/config/zernike.js